import {
  APP_INITIALIZER,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { AnalyticsService, AnalyticsServiceConfig } from './analytics.service';
import { directives } from './directives';

@NgModule({
  declarations: [...directives],
  exports: [...directives],
  providers: [
    AnalyticsService,
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => undefined,
      deps: [AnalyticsService],
      multi: true,
    },
  ],
})
export class AnalyticsModule {
  constructor(@Optional() @SkipSelf() parentModule?: AnalyticsModule) {
    if (parentModule) {
      throw new Error(
        'AnalyticsModule is already loaded. Import it in the AppModule only'
      );
    }
  }

  static forRoot(
    config: AnalyticsServiceConfig
  ): ModuleWithProviders<AnalyticsModule> {
    return {
      ngModule: AnalyticsModule,
      providers: [{ provide: AnalyticsServiceConfig, useValue: config }],
    };
  }
}
